import templateUrl from './work-order-employee-claim-form-modal.component.html';

export const WorkOrderEmployeeClaimFormModalComponent = {
    controller: WorkOrderEmployeeClaimFormModalController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    }
};

function WorkOrderEmployeeClaimFormModalController($q, divisionService, employeeService,
    workOrderService, utilityService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;

    vm.onSubmitClaim = onSubmitClaim;

    function onInit() {
        vm.workOrderClaim = {
            // Currently, this modal only exists as a workaround to how Rogers distributes SGI IDs.
            // Sometimes, the SGI ID assigned to the employee by Rogers is temporary, so it needs to be manually claimed by the employee.
            // No need to provide general support for all divisions.
            divisionID: divisionService.divisionIDs.Rogers
        };
        const identityLoaded = employeeService.retrieveIdentity()
            .then(function (identity) {
                vm.employeeID = identity.EmployeeID;
                vm.workOrderClaim.employeeID = vm.employeeID;
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(identityLoaded, "Initial load failed"));
    }

    function onSubmitClaim(addAnother) {
        const request = {
            DivisionID: vm.workOrderClaim.divisionID,
            DivisionWorkOrderID: vm.workOrderClaim.divisionWorkOrderID,
            EmployeeID: vm.workOrderClaim.employeeID,
            CustomerName: kendo.format("{0} {1}", vm.workOrderClaim.customerFirstName, vm.workOrderClaim.customerLastName),
            CustomerAccountNumber: vm.workOrderClaim.customerAccountNumber
        };

        const requestCreated = workOrderService.createWorkOrderEmployeeClaim(request);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(requestCreated, "Submitting claim failed"));

        requestCreated.then(function () {
            alert("Your claim was submitted successfully.")

            if (addAnother) {
                vm.workOrderClaim = {
                    employeeID: vm.employeeID,
                    divisionID: divisionService.divisionIDs.Rogers
                };
            } else {
                vm.close({ $value: vm.workOrderClaim });
            }
        });

    }
}
